var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container",attrs:{"index":"1"}},[(_vm.val >= -1)?_c('div',{staticClass:"number-container",class:(_vm.posFocus + 1 == _vm.val || (_vm.posFocus == 9 && _vm.val == 0))
        ? {'background-button-focus' : _vm.val >= 0 }
        : {'background-button' : _vm.val >= 0 },attrs:{"id":_vm.val <= -1 ? 'empty-box' : ''},on:{"click":_vm.addNumber}},[_c('div',{staticClass:"hover-cover"}),_c('div',{staticClass:"number"},[_vm._v(" "+_vm._s(_vm.val >= 0 ? _vm.val : '')+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }